import { ThemeOptions } from "@mui/material";

/**
 * Lloyds designs are flat — cards/rows use a border/divider instead of a
 * drop shadow at any elevation, unlike the base theme's soft-shadow ramp.
 */
const shadows: ThemeOptions["shadows"] = Array(25).fill("none") as ThemeOptions["shadows"];

export default shadows;
